import { render, staticRenderFns } from "./LicenceHorseStats.vue?vue&type=template&id=701f1390&"
import script from "./LicenceHorseStats.vue?vue&type=script&lang=js&"
export * from "./LicenceHorseStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports